import * as actionTypes from "./actionTypes";

export const initialState = {
  token: null,
  user: {},
  persist: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE:
      return { ...initialState, ...action.session };
    case actionTypes.CLEAR:
      return { ...initialState };
    default:
      return state;
  }
};
